module.exports = __webpack_public_path__ + "img/14_7.f79f772b.png";